<script setup lang="ts">
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { IconOutlineDarkMode } from '@iconify-prerendered/vue-ic';
import DropdownItem from '../common/DropdownItem.vue';
import type { MenuItem } from 'primevue/menuitem';
import { MapColorMode, useDarkMode } from 'shared/themes/composables/darkMode';
import { useLanguageStore } from 'shared/translations/stores/languageStore';

const languageStore = useLanguageStore();
const { translations } = storeToRefs(languageStore);

const darkMode = useDarkMode();
const { mapColorMode } = storeToRefs(darkMode);

const description = computed(() => {

  switch (mapColorMode.value) {
    case 'auto':
      return translations.value.settings.general.auto;
    case 'dark':
      return translations.value.settings.general.dark;
    case 'light':
      return translations.value.settings.general.light;
    default:
      return translations.value.settings.general.auto;
  }
});

const colorModeLabels: Record<MapColorMode, string> = {
  [MapColorMode.Auto]: translations.value.settings.general.auto,
  [MapColorMode.Light]: translations.value.settings.general.light,
  [MapColorMode.Dark]: translations.value.settings.general.dark,
};

const items = computed<MenuItem[]>(() =>
  Object.values(MapColorMode).map((mode) => ({
    label: colorModeLabels[mode],
    command: () => {
      darkMode.setMapColorMode(mode);
    },
  }))
);
</script>

<template>
  <DropdownItem
    :title="translations.settings.general.mapColorMode"
    :description="description"
    :items="items"
  >
    <template #icon><IconOutlineDarkMode style="width: 2rem; height: 2rem"></IconOutlineDarkMode></template>
  </DropdownItem>
</template>
